import PropTypes from "prop-types"
import React from "react"
import * as css from "./RegisterViaZoomButton.module.css"
import zoomIcon from "./zoom-icon.svg"

function RegisterViaZoomButton({ onClick }) {
  return (
    <button className={css.button} onClick={onClick} type="button">
      <img className={css.icon} src={zoomIcon} alt="" aria-hidden="true" />
      Register Via Zoom
    </button>
  )
}

RegisterViaZoomButton.propTypes = {
  onClick: PropTypes.func,
}

export default RegisterViaZoomButton
